import { isExpired } from "react-jwt";
import { UserCache } from "../services";

/**
 * Determines whether the cached JWT token remains valid for the current session.
 * @returns True when the stored token is not expired.
 */
export default function useAuthentication() {

    const token = UserCache.idToken;
    const valid = !isExpired(token);
    return valid;


}